import React from "react";
import { string, bool } from "prop-types";

import { getCollectionSlug } from "../../utils/utils";

import "./see-more.m.css";

const SeeMore = ({ isExternalStory, externalSlug, collection, sections, publisherName }) =>
  publisherName === "quint-hindi" ? null : (
    <div styleName="wrapper">
      <a styleName="see-more-btn" href={isExternalStory ? externalSlug : getCollectionSlug(collection, sections)}>
        SEE MORE
      </a>
    </div>
  );

SeeMore.propTypes = {
  isExternalStory: bool,
  externalSlug: string,
  collection: string,
  sections: string,
  publisherName: string,
};

export default SeeMore;
